import { render } from "./PosLeftbarBack.vue?vue&type=template&id=034aa9b8&scoped=true"
import script from "./PosLeftbarBack.vue?vue&type=script&lang=js"
export * from "./PosLeftbarBack.vue?vue&type=script&lang=js"

import "./PosLeftbarBack.vue?vue&type=style&index=0&id=034aa9b8&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034aa9b8"]])

export default __exports__